import {generateTheme} from 'providers/themeMain';

export const themePoppins = generateTheme();
